<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<div>
		<div>
			<h1 style="padding-top: 2pt; text-indent: 0pt; text-align: center">
				TERMOS E CONDIÇÕES GERAIS DE USO DO PORTAL PILAR
			</h1>
			<p style="padding-top: 4pt; text-indent: 0pt; text-align: left"><br /></p>
			<div class="flex w-full justify-center">
				<p class="s1 updated-at">
					Última atualização em outubro de 2024<span class="p">.</span>
				</p>
			</div>
			<p style="padding-top: 4pt; text-indent: 0pt; text-align: left"><br /></p>
			<p
				style="
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				Estes Termos e Condições Gerais de Uso do Portal Pilar (“<u
					>Termos de Uso</u
				>”) disciplinam o acesso, uso e funcionamento do portal da Pilar voltado
				a compradores e vendedores em busca de imóveis de alto padrão
				(“<u>Portal</u>”) e devem ser seguidos por todos os Usuários
				(“<u>Você</u>”).
			</p>
			<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
			<p
				style="
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				O Portal é disponibilizado e gerenciado pela
				<b>PILAR SOLUÇÕES IMOBILIÁRIAS LTDA, </b>pessoa jurídica de direito
				privado, devidamente inscrita no CNPJ/MF sob o nº 44.139.018/0001-44,
				com sede à Rua Dr. Fernandes Coelho, nº 85, 9º andar, CEP 05423-040, São
				Paulo, Estado de São Paulo (“<u>Pilar</u>”).
			</p>
			<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
			<p style="text-indent: 0pt; text-align: center">
				<u><b>RECOMENDAMOS QUE VOCÊ LEIA ESTES TERMOS DE USO COM ATENÇÃO</b></u
				>, pois, ao utilizar
			</p>
			<p
				style="
					padding-top: 2pt;
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				nosso Portal, Você declara que leu, compreendeu e aceitou estes Termos e
				Condições de Uso bem como a Política de Privacidade da Pilar (“<u
					>Política de Privacidade</u
				>”), disponível
				<NuxtLink to="/termos/politica-de-privacidade" class="a" target="_blank"
					><span
						style="
							color: #1154cc;
							font-family: Calibri, sans-serif;
							font-style: normal;
							font-weight: normal;
							text-decoration: underline;
							font-size: 11pt;
						"
						>aqui</span
					></NuxtLink
				>. O aceite dos documentos implica o reconhecimento de que Você leu e
				entendeu todos os termos presentes. Estes Termos de Uso têm a natureza
				jurídica vinculante, logo, Você se compromete a seguir e cumprir com as
				disposições do documento. <u><b>Caso não concorde com</b></u
				><b> </b
				><u
					><b
						>estes Termos de Uso ou com a Política de Privacidade, Você deve se
						abster de utilizar o</b
					></u
				><b> </b><u><b>Portal</b></u
				>.
			</p>
			<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
			<p
				style="
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				<a href="mailto:privacidade@soupilar.com.br" class="a" target="_blank"
					>Caso tenha qualquer dúvida sobre estes Termos de Uso e/ou sobre a
					Política de Privacidade, entre em contato conosco por meio dos nossos
					canais de atendimento ao Usuário, ou do e-mail </a
				><a href="mailto:privacidade@soupilar.com.br" target="_blank"
					>privacidade@soupilar.com.br.</a
				>
			</p>
			<ol id="l1">
				<li data-list-text="1.">
					<h1
						style="
							padding-top: 2pt;
							padding-left: 41pt;
							text-indent: -35pt;
							text-align: justify;
						"
					>
						SOBRE A PILAR HOME
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l2">
						<li data-list-text="1.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								<u>Pilar Home</u>. O Portal da Pilar, apresentado como Pilar
								Home aos Usuários, consiste em uma plataforma <i>online </i>que
								disponibiliza um portfólio de imóveis residenciais para venda e
								locação, cujas informações abrangem preço, número de cômodos,
								localização, delimitação geográfica da região, e o contato do
								corretor de imóveis responsável por meio da divulgação de seu
								nome e e-mail profissional. Esses imóveis podem estar
								disponíveis publicamente no ambiente do Portal a qualquer
								Usuário ou podem estar na lista de imóveis <i>off market</i>, os
								quais estão sob a responsabilidade de Corretores especializados.
								Todos os imóveis disponibilizados possuem prévia autorização de
								seu proprietário para a divulgação no Portal.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="1.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								<u>Escopo de atuação.</u> A Pilar é uma empresa que oferece
								soluções para o mercado imobiliário, impactando tanto os
								Corretores de imóveis por meio de parcerias comerciais, como
								Compradores e/ou Vendedores. Essas soluções englobam a
								assistência para o Corretor, a seleção e divulgação de imóveis
								para o público interessado, e um <i>marketplace </i>de imóveis
								de alto padrão para venda, compra e locação (“<u>Serviços</u>”).
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="2.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						ACESSO AO PORTAL
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l3">
						<li data-list-text="2.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Para ter acesso ao <i>listing </i>de imóveis oferecidos no
								âmbito do Portal, é necessário que o Usuário realize seu
								cadastro pessoal, e forneça à Pilar todos os dados pessoais
								solicitados, os quais serão tratados de acordo com a Política de
								Privacidade. Esse cadastro será realizado pela autenticação por
								terceiros, ou seja, via outras plataformas digitais as quais
								Você já tenha cadastro, como Google e Facebook, o que infere
								acesso do Usuário ao ambiente externo de plataformas de redes
								sociais, ferramentas de compartilhamento de arquivos, entre
								outros (“<u>Serviços de Terceiros</u>”).
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="2.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Os Usuários serão responsáveis por checar se todos os dados
								fornecidos estão corretos e representam a sua realidade no
								momento do cadastro das informações, garantindo a exatidão,
								clareza, autenticidade, legalidade, validade e atualização das
								informações fornecidas.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="2.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O Usuário deverá sempre manter os dados fornecidos atualizados.
								A Pilar não será obrigada a fiscalizar os dados do Usuário ou
								quaisquer informações adicionais fornecidas pelo Usuário, mas
								poderá, ao seu exclusivo critério, excluir ou questionar os
								dados que lhe pareçam inverídicos ou solicitar a atualização dos
								dados de identificação e cadastro do Usuário.
							</p>
						</li>
						<li data-list-text="2.4.">
							<p
								style="
									padding-top: 1pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								No momento do cadastro, o Usuário, se pessoa física, deverá
								declarar que <b>(i) </b>tem 18 (dezoito) anos de idade ou mais;
								<b>(ii) </b>é plenamente capaz de celebrar contratos em seu
								nome; e <b>(iii) </b>está plenamente ciente e concorda com estes
								Termos de Uso e com a Política de Privacidade. Por outro lado,
								se pessoa jurídica, o Usuário deverá declarar que
								<b>(i) </b>possui poderes para representar e contratar em nome
								da pessoa jurídica em questão; <b>(ii) </b>a pessoa jurídica que
								representa está com seu Cadastro de Pessoa Jurídica regular; e
								<b>(iii) </b>está plenamente ciente e concorda, por si e pela
								pessoa jurídica que representa, com estes Termos de Uso e com a
								Política de Privacidade.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="2.5.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Para o cadastro no Portal, o Usuário deverá informar seu número
								de telefone para que seja fornecida uma senha temporária a cada
								acesso. Essa proteção via dupla autenticação visa elevar o nível
								de segurança durante o acesso dos Usuários ao Portal.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l4">
								<li data-list-text="2.5.1.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 3pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										O Usuário é responsável por manter o sigilo de suas
										informações de cadastro, de forma a isentar a Pilar de
										qualquer dano que venha a sofrer ou causar a terceiros por
										eventual perda ou uso indevido dessas informações. Em caso
										de perda ou roubo dos dados de acesso, seja na própria
										plataforma ou pela autenticação de terceiro, o Usuário
										deverá informar a Pilar imediatamente para que seu acesso
										seja bloqueado e sua conta seja protegida.
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="2.5.2.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 0pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Ao utilizar o Portal, o Usuário concorda que é responsável
										por restringir o acesso ao dispositivo utilizado para
										acessar o Portal, responsabilizando-se por todas as
										atividades que ocorram a partir de sua conta, sendo que a
										Pilar não tem a obrigação de monitorar os acessos ao Portal
										feitos em nome do Usuário.
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
							</ol>
						</li>
						<li data-list-text="2.6.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar se reserva o direito de utilizar todos os meios válidos
								e possíveis para confirmar a identidade do Usuário, as
								informações imputadas por este no Portal e o cumprimento dos
								requisitos para uso do Portal durante o processo de verificação,
								inclusive a partir do uso de serviços fornecidos por terceiros
								de autenticação de dados.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l5">
								<li data-list-text="2.6.1.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 0pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Caso seja detectada qualquer conduta que, a critério
										exclusivo da Pilar, não esteja alinhada com as normas
										estabelecidas ou que represente um risco à segurança ou a
										integridade da Pilar, do Portal, dos Serviços, de outros
										Usuários e/ou de terceiros, a Pilar poderá, a qualquer
										momento e sem necessidade de aviso prévio, adotar quaisquer
										medidas corretivas que entender necessárias. Essas medidas
										podem incluir, mas não se limitam a suspensão temporária,
										bloqueio de acesso, ou até mesmo a exclusão definitiva da
										conta do Usuário envolvido. Essas ações serão tomadas
										visando preservar a confiança e a segurança de todos os
										envolvidos no Portal.
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
							</ol>
						</li>
					</ol>
				</li>
				<li data-list-text="3.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						USUÁRIOS
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l6">
						<li data-list-text="3.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								No contexto da prestação dos Serviços da Pilar no ambiente do
								Portal, Você poderá se identificar como um Comprador, Vendedor
								ou Corretor de imóveis responsável pela
							</p>
							<p
								style="
									padding-top: 2pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: left;
								"
							>
								intermediação. A depender de sua jornada em nosso Portal, Você
								terá acesso a diferentes tipos de funcionalidades.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l7">
								<li data-list-text="3.1.1.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 0pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										<u>Comprador</u>. É o Usuário que utiliza o Portal para
										encontrar o imóvel ideal para comprar ou alugar. Caso Você
										encontre um imóvel que tenha interesse, irá preencher um
										formulário contendo seu nome, telefone de contato e uma
										mensagem pré preenchida com as informações do imóvel. Esse
										formulário será enviado ao Corretor responsável pelo imóvel,
										que entrará em contato com Você para seguir com o
										atendimento.
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="3.1.2.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 0pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										<u>Vendedor</u>. É o Usuário que entra em contato com o time
										Pilar para anunciar seu imóvel no Portal da Pilar, podendo
										este imóvel ser disponibilizado publicamente no Portal ou
										constar na lista de imóveis <i>off market</i>, que apenas
										poderão ser acessados mediante solicitação do interessado.
										Para tanto, Você irá preencher um formulário com informações
										de contato para que seja compartilhadas com um Corretor, que
										será designado por atender o seu imóvel enquanto estiver
										disponível no Portal. A Pilar distribui internamente o
										Corretor responsável por cada imóvel.
									</p>
									<p
										style="padding-top: 9pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="3.1.3.">
									<p
										style="
											padding-left: 41pt;
											text-indent: 0pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										<u>Corretor.</u> É o Usuário responsável por determinados
										imóveis divulgados no Portal, sendo esses imóveis publicados
										na plataforma ou incluídos na lista <i>off market. </i>O
										Corretor também é quem faz a intermediação da aquisição e/ou
										locação do imóvel com as partes interessadas e integra o
										time de parceiros da Pilar.
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
							</ol>
						</li>
					</ol>
				</li>
				<li data-list-text="4.">
					<h1
						style="padding-left: 26pt; text-indent: -17pt; text-align: justify"
					>
						REQUISITOS TÉCNICOS PARA O USO DO PORTAL
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l8">
						<li data-list-text="4.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O uso do Portal dependerá necessariamente de equipamentos e
								dispositivos conectados a uma rede internet, que deverão ser
								independentemente obtidos e contratados pelo Usuário. O acesso e
								a utilização do Portal podem ser prejudicados em razão da versão
								do sistema operacional do dispositivo do Usuário ou das próprias
								condições técnicas dos dispositivos que o Usuário utiliza. A
								adequação e atualização de dispositivos, navegadores ou versões
								de sistemas operacionais para o funcionamento do Portal é
								responsabilidade do Usuário.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="4.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Ainda, a Pilar não tem qualquer controle e ingerência sobre os
								Serviços de Terceiros, operados. Esses Serviços de Terceiro
								podem incluir, por exemplo, aplicativos de mensagens
								instantâneas, aplicativos de armazenamento em nuvem, entre
								outros. Nesses casos, o uso de tais Serviços de Terceiros estará
								sujeito aos termos e condições específicos de cada Serviço de
								Terceiro, os quais deverão ser acessados, compreendidos e
								integralmente aceitos pelo Usuário.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="4.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar não possui controle sobre os Serviços de Terceiros e não
								será responsável pelos conteúdos, práticas e serviços ofertados
								por quaisquer terceiros. A presença de conteúdo de terceiros no
								Portal não implica relação de endosso, aprovação, sociedade, de
								supervisão, de cumplicidade ou solidariedade da Pilar para com
								esses sites e seus conteúdos.
							</p>
						</li>
						<li data-list-text="4.4.">
							<p
								style="
									padding-top: 1pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar não se responsabiliza por eventuais danos sofridos em
								razão da descontinuação e/ou alteração de versões antigas do
								Portal, tampouco por danos sofridos em razão de falhas de
								Serviços de Terceiros.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="5.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						CONTRAPRESTAÇÃO
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l9">
						<li data-list-text="5.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar se reserva o direito de cobrar taxa de manutenção dos
								Usuários pela utilização do Portal, mediante comunicação prévia.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="5.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								As transações financeiras referentes à compra e venda dos
								imóveis disponíveis no Portal serão realizadas diretamente entre
								comprador, vendedor e imobiliária fora do ambiente do Portal, de
								modo que o Serviço se restringe ao uso do Portal e as
								negociações de venda e aquisição serão reguladas pelas partes
								responsáveis em instrumentos contratuais específicos.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="6.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						DEVERES DO USUÁRIO
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l10">
						<li data-list-text="6.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O Usuário concorda em fazer uso adequado e lícito do Portal, de
								acordo com a legislação aplicável, com estes Termos de Uso e com
								a Política de Privacidade, e com qualquer outro documento
								aplicável. Assim, o Usuário concorda que <u><b>não</b></u
								><b> </b>praticará, auxiliará ou possibilitará que outras
								pessoas pratiquem nenhuma das seguintes atividades:
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l11">
								<li data-list-text="(i)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Fazer uso do Portal para fins ou efeitos ilegais,
										prejudiciais aos interesses ou direitos da Pilar, de outros
										Usuários, de vendedores ou de terceiros, ou que de qualquer
										forma possam prejudicar, desabilitar ou deteriorar o Portal
										ou impedir o uso normal do Portal por outros Usuários;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(ii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Reproduzir, adaptar, modificar e/ou empregar, no todo ou em
										parte, para qualquer fim, o Portal ou qualquer conteúdo da
										Pilar ou de outros Usuários, sem a autorização expressa;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(iii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Copiar, ceder, licenciar, sublicenciar, vender, alugar, dar
										em garantia, distribuir, compartilhar, reproduzir, doar,
										alienar de qualquer forma, disponibilizar, dar acesso ao
										Portal ou transferir total ou parcialmente, sob quaisquer
										modalidades, gratuita ou onerosamente, provisória ou
										permanentemente, o software do Portal, assim como seus
										módulos, partes, manuais ou quaisquer informações relativas
										a ele, incluindo qualquer conteúdo da Pilar ou de outros
										Usuários;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(iv)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Usar, imitar ou reproduzir o nome Pilar, qualquer marca da
										Pilar, logotipo, o layout e design de qualquer página do
										Portal ou qualquer informação de propriedade da Pilar, sem o
										consentimento expresso, prévio e por escrito da Pilar;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(v)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Violar direitos autorais e a propriedade intelectual da
										Pilar, de outros Usuários e de terceiros, bem como se
										apropriar de propriedade intelectual ou conteúdo da Pilar ou
										de outros Usuários, por meio de qualquer ferramenta ou
										mecanismo;
									</p>
								</li>
								<li data-list-text="(vi)">
									<p
										style="
											padding-top: 1pt;
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Permitir que outros Usuários utilizem seu acesso ou tentem
										se passar por si, bem como utilizar acessos de outros
										Usuários ou tentar se passar por outros Usuários, por
										exemplo, falsificando, omitindo ou simulando endereços IPs,
										de rede ou de correio eletrônico, na tentativa de ocultar
										identidade ou autoria ou ainda responsabilizar terceiros
										inocentes;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(vii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Decompilar, promover e/ou facilitar qualquer engenharia
										reversa, acesso indevido, ou tentativa de engenharia reversa
										ou acesso indevido, ao código fonte do Portal;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(viii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Destruir, alterar, desabilitar ou, de qualquer outra forma,
										danificar os dados, programas ou documentos eletrônicos e
										outros disponíveis no Portal;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(ix)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Penetrar ou testar a vulnerabilidade do Portal ou de
										qualquer sistema ou rede social da Pilar, bem como quebrar
										ou tentar quebrar suas medidas de segurança ou autenticação;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(x)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Empregar softwares, técnicas e/ou artifícios com o intuito
										de coletar dados ou utilizar indevidamente o Portal para
										práticas nocivas à Pilar, a outros Usuários ou a terceiros,
										tais como <i>hacking</i>, <i>scraping</i>, <i>crawling</i>,
										<i>exploits</i>, <i>spamming</i>, <i>flooding</i>,
										<i>spoofing</i>, <i>crashing</i>, <i>root kits </i>etc.;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xi)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Introduzir ou espalhar vírus de computador ou quaisquer
										outros sistemas físicos ou lógicos e praticar atos que
										possam causar danos ou prejudicar o Portal, a Pilar, outros
										Usuários e/ou terceiros, inclusive por meio da publicação ou
										transmissão de qualquer arquivo que contenha vírus,
										<i>worms</i>, <i>malwares</i>, <i>bot</i>, <i>backdoor</i>,
										<i>spyware</i>, <i>rootkit</i>, cavalos de Tróia ou qualquer
										outro programa contaminante ou destrutivo;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Realizar qualquer ação que cause prejuízo ou afete
										negativamente, ou que possa causar prejuízo ou afetar
										negativamente, o devido funcionamento do Portal e/ou a
										reputação da Pilar de qualquer forma;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xiii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Utilizar o Portal com o objetivo de desenvolver ou operar
										produto semelhante ou concorrente ao Portal ou qualquer
										outro produto ou serviço da Pilar, bem como com o objetivo
										de facilitar o acesso ao Portal por um concorrente da Pilar;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xiv)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Utilizar ou permitir o uso do Portal para finalidade diversa
										daquela para a qual foi disponibilizado pela Pilar, bem como
										para, por, ou em benefício de terceiros;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xv)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											text-align: left;
										"
									>
										Fornecer informações inverídicas, inexatas ou fictícias à
										Pilar;
									</p>
									<p
										style="padding-top: 4pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xvi)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											text-align: left;
										"
									>
										Envolver-se em atividades suspeitas e/ou potencialmente
										fraudulentas;
									</p>
									<p
										style="padding-top: 4pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xvii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Violar ou ameaçar os direitos e os interesses da Pilar, de
										outros Usuários ou de terceiros;
									</p>
								</li>
								<li data-list-text="(xviii)">
									<p
										style="
											padding-top: 1pt;
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Praticar atos contrários à moral, à legislação vigente ou à
										ordem pública, incluindo, mas não se limitando, a atividades
										ilícitas como corrupção, lavagem de dinheiro ou qualquer
										outro comportamento ilegal ou antiético; e
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(xix)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Recusar-se a fornecer informações ou documentos
										eventualmente solicitados pela Pilar para processos de
										investigação, verificação de identidade, cumprimento de
										ordens judiciais, exigências regulatórias e/ou outras
										finalidades definidas pela Pilar.
									</p>
								</li>
							</ol>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="6.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Eventuais lesões a direito próprio da Pilar, de outros Usuários
								ou de terceiros serão de inteira responsabilidade do Usuário que
								as causou. Esse Usuário responderá pelos danos e/ou prejuízos de
								qualquer natureza decorrentes do descumprimento de qualquer uma
								das obrigações destes Termos de Uso, da Política de Privacidade,
								ou das leis e regulamentações aplicáveis.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="7.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						DIREITOS DA PILAR
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l12">
						<li data-list-text="7.1.">
							<p
								style="
									padding-left: 41pt;
									text-indent: -35pt;
									text-align: justify;
								"
							>
								Poderá a Pilar, a seu exclusivo critério:
							</p>
							<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l13">
								<li data-list-text="(i)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Acrescentar, modificar, suspender ou encerrar, parcial ou
										totalmente, as funcionalidades ou atividades do Portal, a
										qualquer tempo, sem a necessidade de comunicação prévia;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(ii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Realizar toda e qualquer averiguação, investigação, análise
										interna de dados relacionados ao uso do Portal pelo Usuário
										e adoção de quaisquer medidas corretivas com a finalidade de
										corrigir problemas, evitar fraudes, atender solicitações do
										Usuário e qualquer outro fim necessário para preservação da
										integridade do Portal, dos Usuários ou terceiros; e/ou
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(iii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											line-height: 114%;
											text-align: justify;
										"
									>
										Bloquear ou suspender, sem necessidade de comunicação
										prévia, o acesso do Usuário ao Portal, temporária ou
										definitivamente, em caso de inobservância ou suspeita de
										inobservância de quaisquer das obrigações assumidas nestes
										Termos de Uso, na Política de Privacidade ou nos diplomas
										legais aplicáveis;
									</p>
								</li>
							</ol>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="7.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar reserva-se o direito e o poder de determinar, a seu
								exclusivo critério, quando considera ter havido uma violação ou
								uma suspeita de violação de qualquer uma das disposições
								estabelecidas nestes Termos de Uso, na Política de Privacidade,
								e na legislação aplicável, sem necessidade de prova. Nesses
								casos, a Pilar poderá, sem prejuízo de outras medidas, por si ou
								por terceiros e a qualquer tempo, sem a necessidade de aviso ou
								notificação prévia ou posterior ao Usuário: <b>(i) </b>advertir
								o Usuário; <b>(ii) </b>suspender ou limitar o acesso do Usuário
								ao Portal e demais soluções da Pilar; <b>(iii) </b>suspender ou
								bloquear funcionalidades do Portal ao Usuário;
								<b>(iv) </b>abster-se de prestar os Serviços ao Usuário no
								futuro; e/ou <b>(v) </b>tomar outras providências cíveis ou
								criminais que entender necessárias para o cumprimento destes
								Termos de Uso, para o bom funcionamento do Portal e para a
								reparação dos respectivos danos causados. Nessas hipóteses, o
								Usuário concorda em exonerar totalmente a Pilar de toda e
							</p>
							<p
								style="
									padding-top: 2pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								qualquer responsabilidade decorrente de quaisquer prejuízos ou
								danos com relação à perda e/ou indisponibilidade de conteúdos ou
								em geral e/ou por perdas, danos e lucros cessantes, inclusive
								aqueles decorrentes da impossibilidade de compra ou venda de
								imóveis.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="8.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						PROTEÇÃO DE DADOS
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l14">
						<li data-list-text="8.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O acesso e utilização do Portal sujeitam o Usuário ao tratamento
								de determinadas informações de sua titularidade, incluindo dados
								pessoais, nos termos da Lei nº 13.709/18 (Lei Geral de Proteção
								de Dados). Ao realizar seu cadastro no Portal, o Usuário
								concorda com a
								<NuxtLink
									to="/termos/politica-de-privacidade"
									class="s4"
									target="_blank"
									>Política de
									<span
										style="
											color: #1154cc;
											font-family: Calibri, sans-serif;
											font-style: normal;
											font-weight: normal;
											text-decoration: underline;
											font-size: 11pt;
										"
										>Privacidade</span
									></NuxtLink
								>, que deverá ser lida e compreendida pelo Usuário, bem como com
								o tratamento de seus dados pela Pilar, que será realizado
								conforme indicado na Política de Privacidade.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="9.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						PROPRIEDADE INTELECTUAL
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l15">
						<li data-list-text="9.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Estes Termos de Uso concedem ao Usuário uma licença pessoal,
								revogável, não exclusiva e intransferível de uso do Portal para
								o fim exclusivo previsto neste documento. Essa licença não
								concede ao Usuário o direito de usar o Portal para qualquer
								propósito que não esteja previsto expressamente nestes Termos de
								Uso. Dessa forma, a licença não autoriza que o Usuário, sem
								qualquer limitação, copie, modifique, distribua, venda ou alugue
								o Portal, os serviços e os conteúdos da Pilar e de outros
								Usuários disponibilizados e/ou viabilizados pelo Portal, bem
								como não que o Usuário acesse o código-fonte do software usado
								no Portal ou baixe e/ou modifique o Portal ou qualquer parte
								dele.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="9.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Nada nestes Termos de Uso deve ser entendido como uma renúncia
								de direitos pela Pilar, que seguirá detentora de todos os
								direitos, títulos, interesses e propriedade relativos ao Portal.
								Nesse sentido, o Usuário reconhece e aceita que todos os
								direitos de propriedade intelectual e industrial relacionados ao
								Portal e aos conteúdos e/ou quaisquer outros elementos inseridos
								no Portal (incluindo, sem limitação, códigos html, scripts,
								marcas, logotipos, ícones de botão, nomes comerciais, slogans
								comerciais, textos, imagens, ilustrações, fotografias, gráficos,
								designs, trade-dress, sons, dados, bases de dados, ícones,
								software, programas de computador, códigos-fonte, fluxogramas,
								apresentação, áudio e vídeo e/ou quaisquer outros direitos de
								propriedade intelectual e industrial de qualquer natureza)
								pertencem e continuarão pertencendo exclusivamente à Pilar, de
								forma que o Usuário não adquire, por meio destes Termos de Uso,
								nenhum direito da Pilar e/ou relacionados ao Portal, seja ele um
								direito de propriedade intelectual ou qualquer outro direito,
								não podendo utilizar qualquer conteúdo ou elemento inserido no
								Portal sem a autorização prévia e expressa pela Pilar.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="9.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Usuário está ciente e concorda que todo conteúdo enviado para a
								Pilar ou para o Portal (incluindo avaliações, feedbacks,
								informações, dados e interações, depoimentos, sugestões,
								reclamações, ideias, informações, comentários, contatos e
								interações por qualquer meio com a Pilar ou por meio do Portal)
								passa a pertencer automaticamente à Pilar, a qual será a única e
								exclusiva titular dos direitos de propriedade intelectual sobre
								referido conteúdo. Caso a cessão dos direitos de propriedade
								intelectual sobre o conteúdo criado pelo Usuário e compartilhado
							</p>
							<p
								style="
									padding-top: 2pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								com a Pilar ou por meio do Portal seja vedada pelas leis
								aplicáveis, o Usuário, desde já, concede à Pilar uma licença
								global, gratuita, ilimitada, não revogável e válida por prazo
								perpétuo (ou pelo período máximo de proteção legal) para uso e
								exploração do conteúdo, da forma como a Pilar melhor aproveitar
								e a seu exclusivo critério.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="10.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						RESPONSABILIDADE
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l16">
						<li data-list-text="10.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O uso que o Usuário faz do Portal e demais soluções da Pilar é
								de sua inteira responsabilidade e risco, sendo que o Portal é
								fornecida no estado em que se encontra. Nesse sentido, a Pilar
								não garante que:
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l17">
								<li data-list-text="(i)">
									<p
										style="
											padding-left: 42pt;
											text-indent: -36pt;
											line-height: 114%;
											text-align: left;
										"
									>
										O acesso ao Portal, seu conteúdo e/ou sua operação serão
										ininterruptos ou livres de erros;
									</p>
									<p
										style="padding-top: 2pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(ii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											text-align: left;
										"
									>
										O Portal e os serviços atenderão às necessidades e
										expectativas do Usuário;
									</p>
									<p
										style="padding-top: 4pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(iii)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											text-align: left;
										"
									>
										O Portal funcionará de maneira pontual e segura; e/ou
									</p>
									<p
										style="padding-top: 4pt; text-indent: 0pt; text-align: left"
									>
										<br />
									</p>
								</li>
								<li data-list-text="(iv)">
									<p
										style="
											padding-left: 41pt;
											text-indent: -35pt;
											text-align: left;
										"
									>
										Quaisquer erros no conteúdo ou no Portal serão efetivamente
										corrigidos.
									</p>
								</li>
							</ol>
							<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="10.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar se esforça ao máximo para prevenir infecções, alterações
								ou vírus em seus próprios sistemas (<i>hardware </i>e
								<i>software</i>), mas não pode garantir a ausência destes ou de
								outros elementos potencialmente nocivos, que possam causar
								alterações em programas, aplicativos, dispositivos ou
								dispositivos de seus visitantes, nem assume responsabilidade por
								danos que possam ser gerados como resultado.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="10.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar não se responsabiliza por danos de qualquer espécie
								resultantes de atos ilegais praticados por terceiros por meio do
								nosso Portal, tais como, <i>hacking </i>de contas,
								<i>hacking </i>da web, falsificação de identidade de Usuários,
								violação a leis de qualquer tipo, entre outras.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="10.4.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar não será responsável, em nenhuma hipótese, ainda que em
								caráter solidário ou subsidiário, por danos ou prejuízos
								decorrentes de <b>(i) </b>atos dos Usuários e/ou de terceiros;
								<b>(ii) </b>situações de caso fortuito ou força maior, nos
								termos do art. 393 da Lei nº 10.406, de 10 de janeiro de 2002
								(Código Civil); <b>(iii) </b>demora ou incapacidade de
								utilização correta do Portal; e
							</p>
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								<b>(iv) </b>indisponibilidade ou instabilidade do Portal,
								incluindo as causadas por programas nocivos ao Portal (tais como
								vírus, <i>trojans </i>e <i>hackers</i>, <i>malwares </i>e
								<i>ransomwares</i>), suspensão do acesso ao Portal, falhas no
								sistema de informática ou nos servidores do Portal ou em sua
								conectividade com a internet de modo geral.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="10.5.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								O Usuário concorda em defender, indenizar e manter indene a
								Pilar e suas afiliadas, diretores, empregados, investidores e
								corretores, de e contra quaisquer encargos, reclamações, multas,
								penalidades, reversões, <i>chargebacks</i>, ações, demandas,
								incluindo, mas não limitado a custos judiciais e honorários
								advocatícios razoáveis, ou quaisquer outras obrigações
								resultantes: <b>(i) </b>da eventual utilização indevida do
								Portal; <b>(ii) </b>da violação destes Termos de Uso, da
								Política de Privacidade, de outras políticas e contratos aos
								quais esteja vinculado ou das leis
							</p>
							<p
								style="
									padding-top: 2pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: left;
								"
							>
								e regulamentações aplicáveis; e <b>(iii) </b>de quaisquer
								demandas relacionadas a qualquer ação ou omissão ou de qualquer
								outra forma relacionada à utilização, pelo Usuário, do Portal.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="10.6.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								EM NENHUM CASO A PILAR SERÁ RESPONSÁVEL POR DANOS INDIRETOS OU A
								TERCEIROS DECORRENTES DESTES TERMOS DE USO, INCLUSIVE POR MORTE,
								LESÃO OU PREJUÍZOS DE QUALQUER NATUREZA OCASIONADOS A TERCEIROS,
								BEM COMO POR LUCROS CESSANTES OU PERDA DE RECEITA DE QUALQUER
								NATUREZA PELO USUÁRIO, INCLUINDO, AINDA, AQUELES OCASIONADOS POR
								CORRUPÇÃO OU PERDA DE DADOS, FALHA DE TRANSMISSÃO OU RECEPÇÃO DE
								DADOS, NÃO CONTINUIDADE DO NEGÓCIO OU QUALQUER OUTRO PREJUÍZO OU
								PERDA COMERCIAL, DECORRENTES OU RELACIONADOS AO USO OU
								INABILIDADE EM USAR O PORTAL, POR QUALQUER OUTRO MOTIVO.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
							<ol id="l18">
								<ol id="l19">
									<li data-list-text="1.1.">
										<p
											style="
												padding-left: 6pt;
												text-indent: 0pt;
												line-height: 108%;
												text-align: justify;
											"
										>
											NADA DO QUE ESTÁ ESCRITO NESTES TERMOS DE USO TEM COMO
											INTENÇÃO EXCLUIR OU LIMITAR QUALQUER CONDIÇÃO, GARANTIA,
											DIREITO OU RESPONSABILIDADE QUE NÃO POSSA SER LEGALMENTE
											EXCLUÍDA OU LIMITADA. ALGUMAS JURISDIÇÕES NÃO PERMITEM A
											EXCLUSÃO DE CERTAS GARANTIAS OU CONDIÇÕES OU A LIMITAÇÃO
											OU EXCLUSÃO DE RESPONSABILIDADE POR PERDAS E DANOS.
											CONSEQUENTEMENTE, APENAS SERÃO APLICÁVEIS AS LIMITAÇÕES
											QUE FOREM PERMITIDAS POR LEI NA JURISDIÇÃO DO CLIENTE. NOS
											CASOS EM QUE EXCLUSÃO DE RESPONSABILIDADE NÃO SE MOSTRAR
											POSSÍVEL, MAS A LIMITAÇÃO DE RESPONSABILIDADE FOR
											LEGALMENTE APLICÁVEL, A RESPONSABILIDADE TOTAL DA PILAR
											ESTARÁ LIMITADA A R$ 1.000,00 (MIL REAIS).
										</p>
									</li>
								</ol>
							</ol>
							<p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="11.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						VIGÊNCIA E RESCISÃO
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l20">
						<li data-list-text="11.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Estes Termos de Uso e a Política de Privacidade serão válidos
								por prazo indeterminado, a partir de seu aceite, podendo ser
								rescindidos ou modificados unilateralmente pela Pilar a qualquer
								tempo, por qualquer motivo, sem qualquer ônus, mediante simples
								comunicação por meio do próprio Portal ou de mensagem para o
								e-mail ou telefone indicado por Você quando realizado o seu
								cadastro.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="11.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								<a
									href="mailto:pilarhomes@soupilar.com.br"
									class="a"
									target="_blank"
									>O Usuário poderá, a qualquer momento, solicitar o
									cancelamento de sua conta no Portal, mediante solicitação
									realizada diretamente por meio do e-mail </a
								>pilarhomes@soupilar.com.br, de forma a encerrar seu
								relacionamento com a Pilar, mas mantendo junto à Pilar, outros
								Usuários e/ou terceiros todas as obrigações que sobrevivam à
								rescisão destes Termos de Uso. A Pilar cancelará a conta do
								Usuário em até 15 (quinze) dias contados do recebimento da
								solicitação de cancelamento.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="11.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar poderá, imediatamente, sem a necessidade de aviso
								prévio, rescindir estes Termos de Uso e/ou parar de oferecer ou
								impedir o acesso ao Portal ao Usuário nas seguintes hipóteses:
								<b>(i) </b>se o Usuário tiver violado suas obrigações conforme
								estes Termos de Uso, a Política de Privacidade, outras políticas
								da Pilar ou leis aplicáveis; <b>(ii) </b>se a Pilar acreditar,
								de boa-fé, que a referida ação seja razoavelmente necessária
								para proteger a segurança ou a propriedade da Pilar, de seus
								Usuários, ou de terceiros; <b>(iii) </b>para cumprir com a lei
								aplicável, ou com a decisão ou determinação de um tribunal,
								outro órgão governamental ou autoridade competente; e/ou
								<b>(iv) </b>se o Usuário tiver fornecido informações
								incompletas, desatualizadas, fraudulentas ou imprecisas.
							</p>
						</li>
						<li data-list-text="11.4.">
							<p
								style="
									padding-top: 1pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Caso estes Termos de Uso sejam rescindidos e/ou o acesso do
								Usuário ao Portal seja descontinuado por qualquer motivo, os
								dados do Usuários serão tratados apenas pelo tempo e na forma
								previstos na Política de Privacidade.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="12.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						MODIFICAÇÕES E ATUALIZAÇÕES
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l21">
						<li data-list-text="12.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Nós poderemos, a qualquer tempo, alterar estes Termos de Uso e a
								Política de Privacidade, quando acharmos pertinente. Quaisquer
								alterações serão informadas por meio do Portal, do e-mail e/ou
								do telefone indicado pelo Usuário no momento de realização de
								seu cadastro.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="12.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Exceto quando o consentimento expresso for obrigatório, caso o
								Usuário continue utilizando o Portal e/ou não apresente objeções
								às alterações e aos novos termos informados pela Pilar em até 30
								(trinta) dias contados do recebimento de notificação pelo
								Usuário, será entendido que este concorda, tácita, irretratável
								e irrevogavelmente com as alterações. Caso não concorde com as
								alterações aos Termos de Uso, Você deverá deixar de utilizar o
								Portal imediatamente.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
					</ol>
				</li>
				<li data-list-text="13.">
					<h1
						style="padding-left: 41pt; text-indent: -35pt; text-align: justify"
					>
						DISPOSIÇÕES GERAIS
					</h1>
					<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
						<br />
					</p>
					<ol id="l22">
						<li data-list-text="13.1.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Caso qualquer disposição destes Termos de Uso seja considerada
								ilegal, nula ou inexequível por qualquer razão, as disposições
								restantes não serão afetadas e serão válidas e aplicáveis na
								máxima extensão possível. Estes Termos de Uso e a Política de
								Privacidade constituem a totalidade do acordo sobre as condições
								de uso do Portal.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="13.2.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Qualquer falha da Pilar em impor ou exercer qualquer disposição
								destes Termos de Uso, da Política de Privacidade ou direitos
								conexos, não constitui uma renúncia a esse direito ou
								disposição.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="13.3.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								A Pilar pode ceder ou transferir estes Termos de Uso e Política
								de Privacidade mediante simples comunicação ao Usuário. Ainda, a
								Pilar poderá efetuar qualquer alteração de seu controle
								societário sem a necessidade de uma autorização do Usuário ou
								envio de uma comunicação a este. O Usuário fica proibido de
								ceder, alugar, licenciar ou de qualquer forma transferir as
								obrigações decorrentes destes Termos de Uso.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="13.4.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Ao utilizar o Portal ou nos enviar e-mails, mensagens ou outros
								tipos de comunicação a partir de qualquer aparelho eletrônico, o
								Usuário se comunicará eletronicamente conosco. O USUÁRIO
								AUTORIZA A PILAR A ENVIAR COMUNICAÇÕES ELETRÔNICAS POR VÁRIOS
								MEIOS, TAIS COMO E-MAIL, MENSAGENS POR APLICATIVOS DE TERCEIROS
								(INCLUINDO WHATSAPP OU OUTRO SISTEMA DE MENSAGENS SEMELHANTE
								EVENTUALMENTE USADO), MENSAGENS DE TEXTO (SMS), MENSAGENS
								“<i>PUSH</i>” OU INFORMAÇÕES POR APLICATIVO. O USUÁRIO CONSENTE
								E AUTORIZA O ENVIO/RECEBIMENTO DE QUAISQUER CONTATOS,
								NOTIFICAÇÕES, MENSAGENS, DIVULGAÇÕES E DEMAIS COMUNICAÇÕES
								ENTREGUES ELETRONICAMENTE REALIZADAS PELO PORTAL.
							</p>
						</li>
						<li data-list-text="13.5.">
							<p
								style="
									padding-top: 1pt;
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Estes Termos de Uso serão regidos e interpretados exclusivamente
								segundo as leis do Brasil.
							</p>
							<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
								<br />
							</p>
						</li>
						<li data-list-text="13.6.">
							<p
								style="
									padding-left: 6pt;
									text-indent: 0pt;
									line-height: 114%;
									text-align: justify;
								"
							>
								Anteriormente a qualquer início de processo litigioso, as Partes
								se comprometem a tentar resolver o conflito amigavelmente.
								Quando tal procedimento não for bem-sucedido, as Partes poderão
								submeter qualquer demanda relacionada a estes Termos de Uso, à
								Política de Privacidade ou ao Portal ao Poder Judiciário
								Brasileiro, incidindo a lei brasileira e elegendo o Foro da
								Comarca de São Paulo, Estado de São Paulo, como o único
								competente para dirimir tais litígios, com exclusão de qualquer
								outro, por mais privilegiado que seja.
							</p>
						</li>
					</ol>
				</li>
			</ol>
			<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
			<p
				style="
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				<a href="mailto:privacidade@soupilar.com.br" class="a" target="_blank"
					>Caso Você tenha dúvidas, reclamações ou sugestões acerca do Portal ou
					de suas funcionalidades, deseje obter maiores informações ou
					esclarecimentos sobre a aplicação destes Termos de Uso ou da Política
					de Privacidade, ou para qualquer assunto relacionado a estes Termos de
					Uso, à Política de Privacidade ou ao Portal, Você poderá entrar em
					contato com a Pilar pelo e-mail </a
				>privacidade@soupilar.com.br. Nós teremos satisfação de esclarecer suas
				dúvidas e/ou atender às suas solicitações!
			</p>
			<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
			<h1
				style="
					padding-left: 6pt;
					text-indent: 0pt;
					line-height: 114%;
					text-align: justify;
				"
			>
				AO ACEITAR ESTES TERMOS DE USO, O USUÁRIO DECLARA TER CAPACIDADE LEGAL E
				RECONHECE DE FORMA EXPRESSA E INEQUÍVOCA TER LIDO, COMPREENDIDO E ACEITO
				INTEGRALMENTE SEUS TERMOS E CONDIÇÕES.
			</h1>
		</div>
	</div>
</template>
<script setup lang="ts">
definePageMeta({
	layout: 'empty'
});
</script>
<!-- eslint-disable-next-line custom-rules/no-style-tag -->
<style scoped>
* {
	margin: 0;
	padding: 0;
	text-indent: 0;
}
h1 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
.s1 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: italic;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.p,
p {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
	margin: 0pt;
}
.s4 {
	color: #1154cc;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: underline;
	font-size: 11pt;
}
.a,
a {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
li {
	display: block;
}
#l1 {
	padding-left: 0pt;
	counter-reset: c1 1;
}
#l1 > li > *:first-child:before {
	counter-increment: c1;
	content: counter(c1, decimal) '. ';
	color: black;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
}
#l1 > li:first-child > *:first-child:before {
	counter-increment: c1 0;
}
#l2 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l2 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l2 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l3 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l3 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l3 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l4 {
	padding-left: 0pt;
	counter-reset: c3 1;
}
#l4 > li > *:first-child:before {
	counter-increment: c3;
	content: counter(c1, decimal) '.' counter(c2, decimal) '.'
		counter(c3, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l4 > li:first-child > *:first-child:before {
	counter-increment: c3 0;
}
#l5 {
	padding-left: 0pt;
	counter-reset: c3 1;
}
#l5 > li > *:first-child:before {
	counter-increment: c3;
	content: counter(c1, decimal) '.' counter(c2, decimal) '.'
		counter(c3, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l5 > li:first-child > *:first-child:before {
	counter-increment: c3 0;
}
#l6 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l6 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l6 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l7 {
	padding-left: 0pt;
	counter-reset: c3 1;
}
#l7 > li > *:first-child:before {
	counter-increment: c3;
	content: counter(c1, decimal) '.' counter(c2, decimal) '.'
		counter(c3, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l7 > li:first-child > *:first-child:before {
	counter-increment: c3 0;
}
#l8 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l8 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l8 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l9 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l9 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l9 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l10 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l10 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l10 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l11 {
	padding-left: 0pt;
	counter-reset: d1 1;
}
#l11 > li > *:first-child:before {
	counter-increment: d1;
	content: '(' counter(d1, lower-roman) ') ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l11 > li:first-child > *:first-child:before {
	counter-increment: d1 0;
}
#l12 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l12 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l12 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l13 {
	padding-left: 0pt;
	counter-reset: e1 1;
}
#l13 > li > *:first-child:before {
	counter-increment: e1;
	content: '(' counter(e1, lower-roman) ') ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
#l13 > li:first-child > *:first-child:before {
	counter-increment: e1 0;
}
#l14 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l14 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l14 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l15 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l15 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l15 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l16 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l16 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l16 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l17 {
	padding-left: 0pt;
	counter-reset: f1 1;
}
#l17 > li > *:first-child:before {
	counter-increment: f1;
	content: '(' counter(f1, lower-roman) ') ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l17 > li:first-child > *:first-child:before {
	counter-increment: f1 0;
}
#l18 {
	padding-left: 0pt;
	counter-reset: g1 1;
}
#l18 > li > *:first-child:before {
	counter-increment: g1;
	content: counter(g1, decimal) ' ';
	color: black;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
}
#l18 > li:first-child > *:first-child:before {
	counter-increment: g1 0;
}
#l19 {
	padding-left: 0pt;
	counter-reset: g2 1;
}
#l19 > li > *:first-child:before {
	counter-increment: g2;
	content: counter(g1, decimal) '.' counter(g2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
#l19 > li:first-child > *:first-child:before {
	counter-increment: g2 0;
}
#l20 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l20 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l20 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l21 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l21 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l21 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
#l22 {
	padding-left: 0pt;
	counter-reset: c2 1;
}
#l22 > li > *:first-child:before {
	counter-increment: c2;
	content: counter(c1, decimal) '.' counter(c2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l22 > li:first-child > *:first-child:before {
	counter-increment: c2 0;
}
.updated-at {
	text-align: left;
	@media screen and (min-width: 640px) {
		text-indent: 20pt;
	}
}
</style>
